module.exports = __webpack_public_path__ + "img/upload-icon.0a82b01a.svg";